import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

import { COLORS } from 'theme';

const PinLocationBIcon = ({
  size = '24px',
  primaryColor = COLORS.kinetikBlack,
  secondaryColor = COLORS.white,
  sx = {},
  ...props
}) => (
  <SvgIcon sx={{ width: size, height: size, ...sx }} {...props}>
    <path
      fill={secondaryColor}
      d="M12 1.58a7.5 7.5 0 0 0-7.5 7.5c0 4.25 4.718 10.522 6.67 12.933.429.53 1.23.53 1.659 0 1.952-2.412 6.67-8.684 6.67-12.933a7.5 7.5 0 0 0-7.5-7.5Z"
    />
    <path
      fill={primaryColor}
      fillRule="evenodd"
      d="M11.999 2.08a7 7 0 0 1 7 7c0 3.965-4.404 9.82-6.226 12.07a.995.995 0 0 1-1.549 0C9.402 18.9 5 13.045 5 9.08a7 7 0 0 1 7-7Zm0 1.375a5.625 5.625 0 1 0 0 11.25 5.625 5.625 0 0 0 0-11.25Z"
      clipRule="evenodd"
    />
    <path
      fill={primaryColor}
      d="M12.099 9.441h-1.27l-.006-.786h1.048c.186 0 .336-.024.452-.072a.513.513 0 0 0 .258-.21.68.68 0 0 0 .081-.345.767.767 0 0 0-.081-.379.469.469 0 0 0-.258-.21 1.234 1.234 0 0 0-.448-.068h-.645v4.338h-1.106V6.46h1.75c.297 0 .562.029.795.087.233.057.431.146.594.266.165.12.29.27.377.451.086.18.129.393.129.638 0 .214-.046.414-.136.599-.088.185-.23.335-.428.45-.197.116-.46.179-.79.188l-.316.303Zm-.044 2.268h-1.507l.4-.909h1.107c.17 0 .308-.028.414-.086a.544.544 0 0 0 .234-.235.726.726 0 0 0 .075-.331.91.91 0 0 0-.072-.375.507.507 0 0 0-.217-.245.762.762 0 0 0-.39-.087h-.991l.007-.786h1.211l.258.31c.315-.007.566.047.754.162a.99.99 0 0 1 .41.447c.084.186.126.382.126.588 0 .342-.07.628-.207.858-.138.229-.343.4-.614.516-.27.115-.602.173-.998.173Z"
    />
  </SvgIcon>
);

PinLocationBIcon.propTypes = {
  size: PropTypes.string,
  primaryColor: PropTypes.string,
  secondaryColor: PropTypes.string,
  sx: PropTypes.object,
};

export default PinLocationBIcon;
